/* eslint-disable max-lines-per-function */
import { isPhone, isTablet } from "common/utils/browser";
import { cn } from "tailwind-variants";
import ColorPicker from "../ColorPicker.vue";
import { trackRudderstackImagePlacementColor } from "common/utils/rudderstack/tracker.react";
import { useDtfStore } from "../store";
import { PRESET_MOCKUP_COLORS } from "../common/constants";
// eslint-disable-next-line import/no-cycle
import MockupButton from "./MockupButton.vue";
import "./PresetMockupColorPicker.scss";

export default function PresetMockupColorPicker({
  index = 0,
  isMockupModal = false,
  ...restProps
}) {
  const store = useDtfStore();
  const isPhoneDevice = isPhone();
  const isTabletDevice = isTablet();

  function presetMockupColor() {
    return store.presetMockupColor[index] || "#E1E1E1";
  }

  function colorPickerSize() {
    if (isPhoneDevice) return "large";
    if (isTabletDevice) return "medium";
    return "small";
  }

  function colors() {
    if (!isMockupModal) {
      if (isPhoneDevice) return PRESET_MOCKUP_COLORS.slice(0, 5);
      if (isTabletDevice) return PRESET_MOCKUP_COLORS.slice(0, 6);
      return PRESET_MOCKUP_COLORS.filter(color => !color.isModalColor);
    }
    return PRESET_MOCKUP_COLORS;
  }

  function handleColorChange(color) {
    store.setPresetMockupColor({
      index,
      color
    });
    const colorName = PRESET_MOCKUP_COLORS.find(c => c.value === color)?.name || "custom";
    const trackProperties = {
      color: colorName,
      hexcode: color
    };
    trackRudderstackImagePlacementColor(trackProperties);
  }

  return (
    <div
      {...restProps}
      className={cn(
        "preset-mockup-color-picker",
        restProps?.className,
        isMockupModal && "preset-mockup-color-picker--mockup-modal"
      )}
    >
      <div className="preset-mockup-color-picker__picker">
        {isMockupModal ? (
          <span className="preset-mockup-color-picker__label"> Preview background </span>
        ) : null}
        <ColorPicker
          value={presetMockupColor()}
          size={colorPickerSize()}
          colors={colors()}
          modal-position="bottom-right"
          onChange={handleColorChange}
          data-testid="color-picker"
        />

        {!isMockupModal ? <MockupButton index={index} data-testid="mockup-button" /> : null}
      </div>
      <p className="preset-mockup-color-picker__info">
        {" "}
        T-shirt not included. Need one?{" "}
        <a href="/?category=T-Shirt&style=Short+Sleeve" data-testid="preset-mockup-color-picker-a">
          Browse our selection!
        </a>
      </p>
    </div>
  );
}
